import React from 'react'
import { displayDate } from './displayDate'
import { displayGroup } from './displayGroup'

interface Props {
	group: string
}

export const NotificationGroupAndDate: React.FC<Props> = ({ group }) => {
	return (
		<div className='group-header text-text-grey-200 dark:text-white'>
			<p className='date'>{displayGroup(group)}</p>
			<p>{displayDate(group)}</p>
		</div>
	)
}
